import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { Star, Moon, Sparkles } from 'lucide-react';
const TarotCardMinimal = ({
  size = 20,
  className = ''
}) => <svg width={size} height={size * 1.5} viewBox="0 0 40 60" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-298" data-mp="22oue9uoapnhg">
    <rect x="1" y="1" width="38" height="58" rx="4" stroke="currentColor" strokeWidth="1.5" data-id="element-299" data-mp="2ck5rg8k22mn3" />
    <circle cx="20" cy="20" r="6" stroke="currentColor" strokeWidth="1" data-id="element-300" data-mp="2qjx1jy7gbivt" />
    <path d="M20 10V30M10 20H30" stroke="currentColor" strokeWidth="1" data-id="element-301" data-mp="2qi3y0rs4xes1" />
    <path d="M12 45L20 37L28 45" stroke="currentColor" strokeWidth="1" data-id="element-302" data-mp="2ll3og6w2ttw6" />
  </svg>;
export function MagicalBackground() {
  const elements = useMemo(() => {
    const types = [Star, Moon, Sparkles, TarotCardMinimal];
    return Array.from({
      length: 25
    }).map((_, i) => ({
      id: i,
      Type: types[i % types.length],
      left: `${Math.random() * 100}%`,
      size: Math.random() * 15 + 10,
      duration: Math.random() * 40 + 40,
      delay: Math.random() * -40,
      opacity: Math.random() * 0.15 + 0.05,
      rotate: Math.random() * 360
    }));
  }, []);
  return <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" data-id="element-303" data-mp="eg99t6hvbwku">
      {/* Background elements */}
      {elements.map(({
      id,
      Type,
      left,
      size,
      duration,
      delay,
      opacity,
      rotate
    }) => <motion.div key={id} style={{
      position: 'absolute',
      left,
      width: size,
      height: size,
      color: id % 2 === 0 ? '#d4af37' : '#9333ea',
      opacity
    }} initial={{
      y: '110vh',
      rotate
    }} animate={{
      y: '-10vh',
      rotate: rotate + 360,
      x: [0, Math.random() * 50 - 25, 0]
    }} transition={{
      duration,
      repeat: Infinity,
      delay,
      ease: 'linear'
    }} data-id="element-304" data-mp="sf8vc5a33vcs">
            <Type size={size} data-id="element-305" data-mp="1c49k9tgyo545" />
          </motion.div>)}
    </div>;
}